import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import  { data } from '../../../data'
import RentalTables from '../Rentals/DashboardTables'
import Pagination from '../Pagination';
import { Trans } from 'react-i18next';


const TableWrapper = styled.div`
    background-color: #262626;
    border-radius: 20px;
    padding: 10px 30px;
    height: 100%;
    width: 100%;
    overflow:auto;

    @media screen and (max-width: 500px){
      margin-top: 0;
      padding: 0;
    }
    
`
const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  padding: 10px 0px;

  @media screen and (max-width:700px){
      justify-content: center;
      padding-bottom: 10px;
    }
  
`
const DisplayIndex = styled.div`


    @media screen and (max-width:700px){
      display: none;
    }
`

const Content = ({rentals, sortTable}) => {

  // states
  const [posts, setPosts] = useState([]);  
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(0);


  useEffect(() => {
    const fecthData = async () =>{
        setLoading(true);
        setPostsPerPage(5)
        setPosts(data);
        setLoading(false);
    }
    
    fecthData()
  }, []);



  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
  // const dataSearch = currentPosts
  const numberOfDisplay = currentPosts.length
  const numberOfPosts = posts.length;

  currentPosts.sort((a, b) => {
    let fa = a.wariableForRent.toLowerCase(),
        fb = b.wariableForRent.toLowerCase();
  
    if (fa < fb) {
        return -1;
    }
    if (fa > fb) {
        return 1;
    }
    return 0;
  });

  if(sortTable === 'level'){
    currentPosts.sort((a, b) => {
      return a.levelOrRank - b.levelOrRank;
    });
  } if (sortTable === 'wearable'){

    currentPosts.sort((a, b) => {
      let fa = a.wariableForRent.toLowerCase(),
          fb = b.wariableForRent.toLowerCase();
    
      if (fa < fb) {
          return -1;
      }
      if (fa > fb) {
          return 1;
      }
      return 0;
    });
  } if (sortTable === "multiplier"){
    currentPosts.sort((a, b) => {
      let fa = a.multiplier,
          fb = b.multiplier
    
      if (fa < fb) {
          return -1;
      }
      if (fa > fb) {
          return 1;
      }
      return 0;
    });
  } if(sortTable === "price"){
    currentPosts.sort((a, b) => {
      let fa = a.rentalPrice,
          fb = b.rentalPrice
    
      if (fa < fb) {
          return -1;
      }
      if (fa > fb) {
          return 1;
      }
      return 0;
    });
  } if (sortTable === "term"){
    currentPosts.sort((a, b) => {
      let fa = a.rentalTerm,
          fb = b.rentalTerm
    
      if (fa < fb) {
          return -1;
      }
      if (fa > fb) {
          return 1;
      }
      return 0;
    });
  }

  var current = currentPosts

  // Pagination Functions
  const paginate = pageNumber => setCurrentPage(pageNumber);
  const prevpage = () =>{
      if(currentPage === 1){
      setCurrentPage(1)
    } else{
      setCurrentPage(currentPage - 1)
    }
  }

  const nextpage = (lastpage) => {
      if(currentPage === lastpage){
        setCurrentPage(lastpage)
      } else{
        setCurrentPage(currentPage + 1)
      }
  }


  

  return (
    <>
    <TableWrapper>
        <RentalTables posts={current} loading={loading} rentals={rentals} />
        <PaginationWrapper>
        <DisplayIndex>
            <Trans i18nKey="content.pagination.displayText">
              Display Index {{numberOfDisplay}} of {{numberOfPosts}} items
            </Trans>
        </DisplayIndex>
        <Pagination 
                  postsPerPage={postsPerPage}
                  totalPosts={posts.length}
                  paginate = {paginate}
                  prevpage = {prevpage}
                  nextpage = {nextpage}
                  currentPage = {currentPage}
                />
        </PaginationWrapper>
    </TableWrapper>

    </>
 )
}

export default Content